import { Button, Form, Input } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React from "react";
import { useTranslation } from "react-i18next";
import { AppraisalSectionProps } from ".";
import { VALIDATION_UTIL } from "../../../../../../utils/validation.utils";
import { InfoCircleIcon } from "../../../../../atoms/icon";


const PurposeFulfillment = (props: AppraisalSectionProps) => {

    const { t } = useTranslation();

    return (
        <div className="section-wrapper">
            <Form.List name="purpose_fulfillment">
                {(fields, { add, remove }) => (
                    <>
                        {fields.map((field, index) => (
                            <React.Fragment key={index} >
                                <Form.Item
                                    name={[field.name, 'id']}
                                    hidden>
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label={t("Appraisal.lbPurpose")}
                                    tooltip={{ title: t("Appraisal.lbPurpose"), icon: <InfoCircleIcon /> }}
                                    name={[field.name, 'title']}
                                    rules={props.purpose_fulfillment?.min_element && props.purpose_fulfillment?.min_element - index >= 1 ? VALIDATION_UTIL.getRulesValidationField("title", props.purpose_fulfillment.required_fields) : undefined}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label={t("Appraisal.lbDescription")}
                                    name={[field.name, 'description']}
                                    rules={props.purpose_fulfillment?.min_element && props.purpose_fulfillment?.min_element - index >= 1 ? VALIDATION_UTIL.getRulesValidationField("title", props.purpose_fulfillment.required_fields) : undefined}>
                                    <TextArea rows={5} placeholder={t("Global.lbTypeHere")} />
                                </Form.Item>
                            </React.Fragment>
                        ))}

                        <Form.Item>
                            <Button className="bg-gray" type="default" shape="round" onClick={() => add()}>
                                {t("Scenario.btnAddMore")}
                            </Button>
                        </Form.Item>
                    </>

                )}
            </Form.List>
        </div>
    )
}

export default PurposeFulfillment;